import HistoricBondCreatePage from "./components/HistoricBondCreatePage";
import useGuardianshipBondCreateHistoric from "./hooks/useGuardianshipBondCreateHistoric";
import GuardianshipHistoricBasicInformationForm from "./components/GuardianshipHistoricBasicInformationForm";
import GuardianshipHistoricGuardianForm from "./components/GuardianshipHistoricGuardianForm";
import GuardianshipHistoricAttorneyInformationForm from "./components/GuardianshipHistoricAttorneyInformationForm";
import { ObligeeInformationForm } from "./Helpers/ObligeeInformation";
import GuardianshipHistoricRequestorInformationForm from "./components/GuardianshipHistoricRequestorInformationForm";
import { BillingInformationForm } from "./Helpers/BillingInformation";
import GuardianshipHistoricOtherDetailsForm from "./components/GuardianshipHistoricOtherDetailsForm";
import GuardianshipHistoricBondNumberSection from "./components/GuardianshipHistoricBondNumberSection";

const GuardianshipBondCreateHistoric = () => (
  <HistoricBondCreatePage
    bondKindLabel="Guardianship"
    useCreateHook={useGuardianshipBondCreateHistoric}
    sections={[
      { key: "basic", Component: GuardianshipHistoricBasicInformationForm, stateKey: "basicInformation" },
      { key: "guardian", Component: GuardianshipHistoricGuardianForm, stateKey: "guardianDetails" },
      { key: "attorney", Component: GuardianshipHistoricAttorneyInformationForm, stateKey: "attorneyInformation" },
      { key: "obligee", Component: ObligeeInformationForm, stateKey: "obligeeInformation" },
      { key: "requestor", Component: GuardianshipHistoricRequestorInformationForm, stateKey: "requestorInformation" },
      { key: "billing", Component: BillingInformationForm, stateKey: "billingInformation" },
      { key: "other", Component: GuardianshipHistoricOtherDetailsForm, stateKey: "otherDetails" },
      {
        key: "bondNumber",
        render: ({ globalState, updateGlobalState, errors }) => (
          <GuardianshipHistoricBondNumberSection
            data={globalState.otherDetails}
            updateData={(data) => updateGlobalState("otherDetails", data)}
            errors={errors}
          />
        ),
      },
    ]}
    submitDisabled={(globalState) => globalState?.basicInformation?.judgeStern === "No"}
  />
);

export default GuardianshipBondCreateHistoric;
